import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_ds_get_licenseplate_by_lookupCodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lookupCode: string }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LocationId?: number, LookupCode?: string, TypeId?: number, Location?: { Id?: number, IsLoose?: boolean, Name?: string, TypeId?: number }, Warehouse?: { Name?: string } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lookupCode)) {
      $missingRequiredInParams.push('\'lookupCode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lookupCode: string    }) {
        if(isNil($inParams.lookupCode)) {
          return true; 
        }
      return false;
    }
}
